import { Component } from '@angular/core';

@Component({
  selector: 'wp-paragraph',
  standalone: true,
  templateUrl: './paragraph.component.html',
  styleUrl: './paragraph.component.scss',
})
export class ParagraphComponent {}
